import { type FC } from 'react'

import { BrandAvatar, HeaderTitle, type HeaderTitleProps } from '@/components'

export const BrandHeaderTitle: FC<Omit<HeaderTitleProps, 'left' | 'title'>> = (props) => (
  <HeaderTitle
    left={<BrandAvatar />}
    title='Dateability'
    {...props}
  />
)
